/** Compact notation so a five-tile row never reflows: 1,284 / 12.9K / 4.2M. */
function compact(value: number): string {
  if (value < 1000) return String(value);
  if (value < 10_000) return value.toLocaleString();
  if (value < 1_000_000) return `${(value / 1000).toFixed(1)}K`;
  return `${(value / 1_000_000).toFixed(1)}M`;
}

export function StatTile({
  label,
  value,
  delta,
  deltaPeriod,
}: {
  label: string;
  value: number;
  delta?: number;
  deltaPeriod?: string;
}) {
  return (
    <div className="panel stat-tile">
      <p className="stat-label">{label}</p>
      <div className="stat-value">{compact(value)}</div>
      {/*
        A negative delta is real — polls and workspaces get deleted — so it is
        shown as a fall rather than collapsed into "no change". Only an exact
        zero is flat.
      */}
      {delta === undefined || delta === 0 ? (
        <div className="stat-delta stat-delta-flat">
          <span className="muted">no change vs prev {deltaPeriod}</span>
        </div>
      ) : (
        <div className={delta > 0 ? 'stat-delta' : 'stat-delta stat-delta-down'}>
          {delta > 0 ? '+' : '−'}
          {compact(Math.abs(delta))} <span className="muted">vs prev {deltaPeriod}</span>
        </div>
      )}
    </div>
  );
}
